import React from "react"
import PropTypes from "prop-types"

const ConfirmCopyLinkIcon = ({ style }) => (
  <svg style={style} viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <circle fill="#7DBE37" cx="12" cy="12" r="12" />
      <path
        stroke="#FFF"
        fill="#FFF"
        d="M10.136 14.83l-3.102-3.103L6 12.761l4.136 4.137L19 8.034 17.966 7z" />
    </g>
  </svg>
)

ConfirmCopyLinkIcon.propTypes = {
  style: PropTypes.object
}

export default ConfirmCopyLinkIcon



// WEBPACK FOOTER //
// ./src/components/icons/confirm-copy-link-icon.jsx